// import logo from './logo.svg'; // Removing this as this was not used // and this will be giving problem while deploying on netlyfy or on vercel

import './App.css';
import Enquiry from './Enquiry';

function App() {
  return (
    <div className="App">
      <Enquiry/>
    </div>
  );
}

export default App;

// Deployment Steps for FrontEnd and Backend for Free

// For of Backend that is express 
// we can use vercel
// 1. create a remote repository for backend
// https://github.com/RishiSetpal/JS_EnqueryApplication_Backend/blob/main/index.js
// 2. login vercel 
// 3. Upload files: 1. package.json, 2. package-lock.json, 3. index.js (Backend files) 4. Vercel.json
// Make use of async await when calling functions as those are fast to execute Event Loop 
// and remove unnecessary callbacks from Backend functions eg:
// , (err, res) => {
//     if (err) {console.log("Mail error: ", err);}
//     else {console.log("Mail sent: ", res);}
// }
// 4. Import from github
// 5. Deploy
// https://vercel.com/rishisetpal/js-enquery-application-backend/GmU1Ltv5CQJz3ZdecnqwMtb8YgzG
// 6. use the link 

// For deployment of UI that is react 
// we can use netlyfy
// 1. create a remote repository for frontend
// https://github.com/RishiSetpal/JS_EnqueryApplication_Frontend/blob/main/src/Enquiry.js
// 2. Login vercel 
// 3. Inport Project from GitHub
// 4. Deploy
// https://app.netlify.com/sites/jolly-genie-c11121/overview

// 10-1
